/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CreateCustomerRequest { 
    firstName?: string;
    lastName?: string;
    codeExternal?: string;
    sex?: CreateCustomerRequest.SexEnum;
    birthDate?: string;
    country?: string;
    birthCountry?: string;
    countryNationality?: string;
    city?: number;
    birthCity?: number;
    postalCode?: string;
    address?: string;
    telephone?: string;
    mobile?: string;
    email?: string;
    occupation?: string;
}
export namespace CreateCustomerRequest {
    export type SexEnum = 'Male' | 'Female';
    export const SexEnum = {
        Male: 'Male' as SexEnum,
        Female: 'Female' as SexEnum
    };
}
